import { Avatar, Box, IconButton, Typography } from '@mui/material';
import MessagePreview from 'components/@home/@messages/ChatPanel/PinnedMessage/MessagePreview';
import CloseIcon from 'mdi-react/CloseIcon';
import { object, oneOf } from 'prop-types';
import React from 'react';
import channelShape from 'shapes/channel';
import messageShape from 'shapes/message';
import { I18n } from 'utils/i18n';

import connector from './connector';

const ContextMessage = ({ actions, message, variant, currentChannel }) => {
  const senderName =
    variant === 'edit'
      ? I18n.t('AdminMenu.Edit')
      : message.isMine && !message.sentAsChannel
        ? I18n.t('LastMessage.You')
        : message.nameNotBlank || message.name || I18n.t('Deleted User');
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 1,
        px: 1.5,
        py: 0.75,
        alignItems: 'center',
        borderBottom: 1,
        borderColor: 'divider',
      }}
    >
      <Box
        sx={{
          width: '3px',
          flex: '0 0 auto',
          alignSelf: 'stretch',
          backgroundColor: 'primary.light',
          borderRadius: '3px',
        }}
      />
      {message.attachments[0]?.meta?.thumb && (
        <Box>
          <Avatar
            variant="rounded"
            sx={{ width: 36, height: 36 }}
            src={message.attachments[0].meta.thumb}
          />
        </Box>
      )}
      <Box sx={{ flexGrow: 1, minWidth: 0, overflow: 'hidden' }}>
        <Typography
          sx={{ fontWeight: 500, color: 'primary.main', fontSize: '0.8rem', lineHeight: 1.3 }}
        >
          {senderName}
        </Typography>
        <Box
          sx={{
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            wordBreak: 'break-word',
            fontSize: '0.8rem',
            lineHeight: 1.3,
          }}
        >
          <MessagePreview message={message} showImages={false} />
        </Box>
      </Box>
      <IconButton
        size="small"
        onClick={() => actions.chatPanel.removeContextMessage(currentChannel._id)}
      >
        <CloseIcon size={16} />
      </IconButton>
    </Box>
  );
};

ContextMessage.propTypes = {
  actions: object.isRequired,
  message: messageShape.isRequired,
  variant: oneOf(['edit', 'reply']).isRequired,
  currentChannel: channelShape.isRequired,
};

export default connector(ContextMessage);
